import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { FaPrint, FaRegFilePdf } from "react-icons/fa";
import { GrDocumentWord } from "react-icons/gr";
import { useUIContext } from "../../context/subContexts/UIContext";
import { IoSettingsOutline } from "react-icons/io5";

const ComprehensiveLawHtml = () => {
  const [htmlContent, setHtmlContent] = useState("");
  const {orderbyLaw}=useParams()
  const [OpenSetting, setOpenSetting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [withLaw, setWithLaw] = useState(false);
  const [ParentBand, setParentBand] = useState(true);
  const [ParentTabsere, setParentTabsere] = useState(true);
  const [withSequence, setWithSequence] = useState(false);
  const [withLawIndex, setWithLawIndex] = useState(false);
  const [error, setError] = useState(null);
  const { subjectId, name } = useParams();
  const [orderLaw,setorderLaw]=useState(JSON.parse(orderbyLaw))


  useEffect(() => {
    const fetchLawHtml = async () => {
      try {
        setLoading(true);
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/Subject/ComprehensiveLawHtml?subject=${subjectId}&withLaw=${withLaw}&withSequence=${withSequence}&withParentBand=${ParentBand}&withParentTabsere=${ParentTabsere}&withLawIndex=${withLawIndex}&OrderbyLaw=${orderLaw}
`,
          {
            headers: {
              accept: "*/*",
              "Content-Type": "application/json",
            },
          }
        );
        
        setHtmlContent(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching law HTML:", err);
        setError("خطا در دریافت اطلاعات قانون جامع");
        setLoading(false);
      }
    };

    if (subjectId) {
      fetchLawHtml();
    }
  }, [subjectId, withLaw, withSequence, ParentTabsere, ParentBand,withLawIndex,orderLaw]);

  const handlePrint = () => {
    window.print();
  };

  const toggleWithLaw = () => {
    setWithLaw(!withLaw);
  };
  const toggleParentTabsere = () => {
    setParentTabsere(!ParentTabsere);
  };
  const toggleParentBand = () => {
    setParentBand(!ParentBand);
  };
  const toggleWithLawIndex = () => {
    setWithLawIndex(!withLawIndex);
  };

  const toggleWithSequence = () => {
    setWithSequence(!withSequence);
  }; 
   const toggleOrderByLaw = () => {
    setorderLaw(!orderLaw);
  };
console.log("order",htmlContent)
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div
          className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
          role="alert"
        >
          <strong className="font-bold">خطا! </strong>
          <span className="block sm:inline">{error}</span>
        </div>
      </div>
    );
  }

  return (
    <HelmetProvider>
      <>
        <Helmet>
          <title>پیش نویس قانون جامع {name}</title>
          {/* <style type='text/css'>
            {`
              @media print {
                .print-button {
                  display: none;
                }
                body {
                  font-family: 'IranSans', Arial, sans-serif;
                }
              }
            `}
          </style> */}
        </Helmet>
        <div className=" rtl">
          <div className="w-full ltr px-5 py-3 flex justify-between items-center z-10 print-button print:hidden">
            <div className=" flex gap-3">
              <div className="relative group">
                <button
                  onClick={handlePrint}
                  className="w-9 h-9 flex items-center justify-center rounded-md
                bg-blue-500 text-white  shadow-md transition-all duration-300
                hover:bg-blue-700  hover:shadow-[0_0_12px_#004225]
                hover:scale-110 active:scale-95"
                  // className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded flex items-center"
                >
                  <FaPrint className="" />
                </button>
                <div className="absolute z-20 top-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1 rounded-md bg-gray-800 text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-10">
                  چاپ
                </div>
              </div>
              <div className="relative group">
                <a
                  href={`https://ilaws.net/output/${subjectId}.docx`}
                  // target="_blank"
                  download
                  className="w-9 h-9 flex items-center justify-center rounded-md
                             bg-sky-600 text-white  shadow-md transition-all duration-300
                             hover:bg-sky-100 hover:text-sky-600 hover:shadow-[0_0_12px_#004225]
                             hover:scale-110 active:scale-95"
                >
                  <GrDocumentWord className="text-[22px] transition-transform duration-300 group-hover:rotate-6" />
                </a>
                <div className="absolute z-20 top-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1 rounded-md bg-gray-800 text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-10">
                  دانلود word
                </div>
              </div>
              <div className="relative group">
                <a
                  href={`https://ilaws.net/output/${subjectId}.pdf`}
                  download
                  // target="_blank"
                  className="w-9 h-9 flex items-center justify-center rounded-md
                               bg-red-600 text-white  shadow-md transition-all duration-300
                               hover:bg-red-100 hover:text-red-600 hover:shadow-[0_0_12px_#004225]
                               hover:scale-110 active:scale-95"
                >
                  <FaRegFilePdf className="text-[22px] transition-transform duration-300 group-hover:rotate-6" />
                </a>
                <div className="absolute z-20 top-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1 rounded-md bg-gray-800 text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-10">
                  دانلود pdf
                </div>
              </div>
            </div>

            {/* <div className='toggle-buttons flex gap-2'>
              <button
                onClick={toggleWithLaw}
                className={`font-IranSans py-2 px-4 rounded flex items-center ${
                  withLaw
                    ? 'bg-green-500 hover:bg-green-700 text-white'
                    : 'bg-gray-200 hover:bg-gray-300 text-gray-800'
                }`}
              >
                نمایش عناوین قوانین
              </button>

              <button
                onClick={toggleWithSequence}
                className={`font-IranSans py-2 px-4 rounded flex items-center ${
                  withSequence
                    ? 'bg-green-500 hover:bg-green-700 text-white'
                    : 'bg-gray-200 hover:bg-gray-300 text-gray-800'
                }`}
              >
                جایگزین نمودن شماره تبویب بجای شماره مواد
              </button>
            </div> */}
            {/* <div dir="rtl" className="toggle-buttons md:flex hidden gap-4">
              <div className="flex items-center gap-2">
                <span className="mr-3 text-md font-medium text-gray-700 font-IranSans">
                  نمایش عناوین قوانین
                </span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    value=""
                    className="sr-only peer"
                    checked={withLaw}
                    onChange={toggleWithLaw}
                  />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                </label>
              </div>
              <div className="flex items-center gap-2">
                <span className="mr-3 text-md font-medium text-gray-700 font-IranSans">
                  نمایش فهرست قوانین
                </span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    value=""
                    className="sr-only peer"
                    checked={withLawIndex}
                    onChange={toggleWithLawIndex}
                  />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                </label>
              </div>
              <div className="flex items-center gap-2">
                <span className="mr-3 text-md font-medium text-gray-700 font-IranSans">
                  جایگزین نمودن شماره تبویب بجای شماره مواد
                </span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    value=""
                    className="sr-only peer"
                    checked={withSequence}
                    onChange={toggleWithSequence}
                  />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                </label>
              </div>

              <div className="flex items-center gap-2">
                <span className="mr-3 text-md font-medium text-gray-700 font-IranSans">
                  نمایش سرشاخه بندها
                </span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    value=""
                    className="sr-only peer"
                    checked={ParentBand}
                    onChange={toggleParentBand}
                  />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                </label>
              </div>

              <div className="flex items-center gap-2">
                <span className="mr-3 text-md font-medium text-gray-700 font-IranSans">
                  نمایش سرشاخه تبصره ها
                </span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    value=""
                    className="sr-only peer"
                    checked={ParentTabsere}
                    onChange={toggleParentTabsere}
                  />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                </label>
              </div>
            </div> */}
              <div className="  relative">
                              <button
                                onClick={() => setOpenSetting(!OpenSetting)}
                                className="flex items-center justify-center w-full"
                              >
                                <IoSettingsOutline className="text-2xl lg:mt-6" />
                              </button>
          
                              {OpenSetting && (
                                <div className="absolute -right-0 mt-2 w-96 bg-white border rounded-md shadow-lg flex flex-col gap-2 p-2 z-30">
                                  <div
                                    dir="rtl"
                                    className="toggle-buttons flex flex-col  gap-4"
                                  >
                                    <div className="flex items-center gap-2">
                                      <span className="mr-3 text-[14px] font-sm text-gray-700 font-IranSans">
                                        نمایش عناوین قوانین
                                      </span>
                                      <label className="relative inline-flex items-center cursor-pointer">
                                        <input
                                          type="checkbox"
                                          value=""
                                          className="sr-only peer"
                                          checked={withLaw}
                                          onChange={toggleWithLaw}
                                        />
                                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                      </label>
                                    </div>
          
                                    <div className="flex items-center gap-2">
                                      <span className="mr-3 text-[14px] font-sm text-gray-700 font-IranSans">
                                        جایگزین نمودن شماره تبویب بجای شماره مواد
                                      </span>
                                      <label className="relative inline-flex items-center cursor-pointer">
                                        <input
                                          type="checkbox"
                                          value=""
                                          className="sr-only peer"
                                          checked={withSequence}
                                          onChange={toggleWithSequence}
                                        />
                                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                      </label>
                                    </div>
          
                                    <div className="flex items-center gap-2">
                                      <span className="mr-3 text-[14px] font-sm text-gray-700 font-IranSans">
                                        نمایش سرشاخه بندها
                                      </span>
                                      <label className="relative inline-flex items-center cursor-pointer">
                                        <input
                                          type="checkbox"
                                          value=""
                                          className="sr-only peer"
                                          checked={ParentBand}
                                          onChange={toggleParentBand}
                                        />
                                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                      </label>
                                    </div>
          
                                    <div className="flex items-center gap-2">
                                      <span className="mr-3 text-[14px] font-sm text-gray-700 font-IranSans">
                                        نمایش سرشاخه تبصره ها
                                      </span>
                                      <label className="relative inline-flex items-center cursor-pointer">
                                        <input
                                          type="checkbox"
                                          value=""
                                          className="sr-only peer"
                                          checked={ParentTabsere}
                                          onChange={toggleParentTabsere}
                                        />
                                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                      </label>
                                    </div>



                                       <div className="flex items-center gap-2">
                                      <span className="mr-3 text-[14px] font-sm text-gray-700 font-IranSans">
                                        نمایش مجموعه منقح
                                      </span>
                                      <label className="relative inline-flex items-center cursor-pointer">
                                        <input
                                          type="checkbox"
                                          value=""
                                          className="sr-only peer"
                                          checked={orderLaw}
                                          onChange={toggleOrderByLaw}
                                        />
                                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
          </div>
          
          {/* <div
            dir="rtl"
            className="toggle-buttons md:hidden grid grid-cols-2 gap-4 px-5"
          >
            <div className="flex items-center gap-2">
              <span className="mr-3 text-md font-medium text-gray-700 font-IranSans">
                نمایش عناوین قوانین
              </span>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  value=""
                  className="sr-only peer"
                  checked={withLaw}
                  onChange={toggleWithLaw}
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
              </label>
            </div>
            <div className="flex items-center gap-2">
              <span className="mr-3 text-md font-medium text-gray-700 font-IranSans">
                نمایش فهرست قوانین
              </span>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  value=""
                  className="sr-only peer"
                  checked={withLawIndex}
                  onChange={toggleWithLawIndex}
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
              </label>
            </div>
            <div className="flex items-center gap-2">
              <span className="mr-3 text-md font-medium text-gray-700 font-IranSans">
                جایگزین نمودن شماره تبویب بجای شماره مواد
              </span>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  value=""
                  className="sr-only peer"
                  checked={withSequence}
                  onChange={toggleWithSequence}
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
              </label>
            </div>

            <div className="flex items-center gap-2">
              <span className="mr-3 text-md font-medium text-gray-700 font-IranSans">
                نمایش سرشاخه بندها
              </span>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  value=""
                  className="sr-only peer"
                  checked={ParentBand}
                  onChange={toggleParentBand}
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
              </label>
            </div>

            <div className="flex items-center gap-2">
              <span className="mr-3 text-md font-medium text-gray-700 font-IranSans">
                نمایش سرشاخه تبصره ها
              </span>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  value=""
                  className="sr-only peer"
                  checked={ParentTabsere}
                  onChange={toggleParentTabsere}
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:right-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
              </label>
            </div>
          </div> */}
          <div
            className=" law-content px-4 font-IranSans leading-10"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        </div>
      </>
    </HelmetProvider>
  );
};

export default ComprehensiveLawHtml;
